// Backend base URL. Override at build time with REACT_APP_API_URL.
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export const apiUrl = (path) => `${API_URL}${path}`;
